/**
 * CSV の1つのセル。
 * 表計算ソフトが式として動かす値（= + - @ と全角の ＝ ＋ － ＠ で始まる値。前に空白を挟んだものも）と、
 * タブ・CR で始まる値は頭に ' を付ける。
 * カンマ・"・改行・CR・タブ・; を含む値は " で囲む（' を付けた値も。囲まないと、区切りとして読む表計算ソフトで
 * 列や行が分かれ、後ろが別のセルの式になる）。
 */
export const csvCell = (value: string | null | undefined): string => {
  const raw = value ?? '';
  const safe = /^\s*[=+\-@＝＋－＠]|^[\t\r]/.test(raw) ? `'${raw}` : raw;
  return /[",;\t\r\n]/.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
};

/** 数値の列のセル。数値はそのまま書き（-5 も数値のまま）、数値でない値は csvCell と同じに扱う */
export const csvNumberCell = (value: unknown): string =>
  typeof value === 'number' ? String(value) : csvCell(value == null ? '' : String(value));
